// Change-log entries for this lesson, newest first (SPEC §7.4 "History").

import type { ChangeLogEntry } from "../../api/types";
import { formatTimestamp, t, translateCode } from "../../i18n/i18n";
import { requireSchool } from "../../session";
import { createElement } from "../../ui/dom";

export function buildLessonHistory(entries: ChangeLogEntry[]): HTMLElement {
  const section: HTMLElement = createElement("section", "card");
  section.append(createElement("h2", "", t("lesson.history")));
  if (entries.length === 0) {
    section.append(createElement("p", "muted", t("lesson.noHistory")));
    return section;
  }

  const list: HTMLUListElement = createElement("ul");
  for (const entry of entries) {
    const when: string = formatTimestamp(entry.at, requireSchool().timeZone);
    const what: string = translateCode("actions", entry.action);
    list.append(createElement("li", "", `${when} — ${entry.userName}: ${what}`));
  }

  section.append(list);
  return section;
}
